import { FunctionalComponent, h } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { OnsiteSearchComponent } from '../../cwc-onsite-search';
import { OnsiteSearchTextResources } from '../../config/onsite-search-configuration';

/**
 * Definition of  parameters that the template needs to work.
 */
interface ResponseErrorTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: OnsiteSearchComponent;
  textResources: OnsiteSearchTextResources;
  // Specify parameters that are required to be passed down to the template here.
}

const ResponseErrorTemplate: FunctionalComponent<ResponseErrorTemplateProps> = ({ controller, textResources }) => (
  <message type="responseError">
    <message-image>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 850.39 850.39">
        <defs>
          <clipPath id="a">
            <path fill="none" stroke-width="0" d="M192.96 617.24h467.11v96.27H192.96z" />
          </clipPath>
        </defs>
        <path
          fill="#f6f0e9"
          d="M701.17 247.31c-46.84-34.63-110.93-23.32-161.22-51.81C293.72 29.59 123.66 272.05 79.29 489.08c-10.71 58.11 6.49 119.62 50.3 160.17 21.13 20.65 42.77 47.02 68.59 61.21 21.07 14.05 32.73 15.79 56.02 23.44 21.65 7.38 71.05 11.19 88.19 13.4 22.78 3.14 87.87 6.03 110.84 6.7 51.41 1.42 83.58 3 133.62-8.93 36.4-6.89 105.72-28.25 115.45-33.84 4.74-2.28 9.84-6.2 14.35-8.79 139.68-108.23 105.96-347.98-15.49-455.14"
        />
        <path
          fill="#dbcab9"
          d="M797.27 578.57c-7.23 22.91-16.44 45.66-28.7 66.42a219.88 219.88 0 0 1-51.91 57.46c-1.91 1.09-3.91 2.42-5.95 3.76-2.81 1.71-5.63 3.38-8.4 5.03-.15.09-.31.17-.47.26-10.26 5.23-88.38 30.07-114.98 33.58-50.05 11.93-82.22 10.35-133.63 8.93-22.97-.67-88.05-3.56-110.84-6.7-17.14-2.21-66.53-6.02-88.18-13.4-23.29-7.65-34.95-9.39-56.02-23.44-25.83-14.19-47.46-40.57-68.6-61.21-26.79-24.8-43.63-57.43-50.22-92.33 45.12-16.68 91.31-22.34 136.5-22.72 29.1-.25 58.14-3.54 87.15-8.47 75.09-12.77 86.43 30.96 161.63 20.24 35.09-9.72 107.53 9.92 190.91 12.72 40.57 1.37 141.71 19.87 141.71 19.87"
        />
        <g clip-path="url(#a)">
          <path
            d="M660.06 651.56c1.11 26.24-81.02 57.88-205.69 62.13s-246.17-27.11-247.28-53.34c-1.11-26.24 100.55-38.23 225.22-42.48s226.64 3.37 227.75 29.61"
            opacity=".08"
          />
        </g>
        <path
          fill="#eee"
          d="M663.8 631.49c0 40.2-104.22 72.79-232.79 72.79s-232.79-32.59-232.79-72.79c0-4.62-.49-11.65 2.15-16.03 20.28-33.73 116.86-56.76 230.64-56.76s217.04 27.08 231.87 62.81c1.29 3.1.91 6.78.91 9.98"
        />
        <path
          fill="#fff"
          d="M663.8 625.82c0 40.2-104.22 72.79-232.79 72.79s-232.79-32.59-232.79-72.79 104.22-72.79 232.79-72.79 232.79 32.59 232.79 72.79M570.37 561.87l-6.9-17.7c43.86-17.11 69.57-40.05 68-51.94-2.29-17.38-11.96-18.8-39.08-18.36l-3.47.05-.25-19 3.42-.05c12.18-.19 24.77-.39 35.23 3.52 13.16 4.92 20.89 15.46 22.98 31.35 1.14 8.63-.57 22.09-15.18 37.17-11.75 12.14-41.48 25.88-64.75 34.96"
        />
        <path
          fill="#eee"
          d="M577.64 610.68c0 23.63-68.22 42.79-152.38 42.79s-152.38-19.16-152.38-42.79 68.22-42.79 152.38-42.79 152.38 19.16 152.38 42.79"
        />
        <path
          fill="#fff"
          d="M457.58 625.66h-53.14c-74.39 0-135.25-60.86-135.25-135.25v-44.77h323.63v44.76c0 74.39-60.86 135.25-135.25 135.25"
        />
        <path
          fill="#eee"
          d="M584.02 480.65v-35h8.8v44.77c0 74.39-60.86 135.25-135.25 135.25H439c79.76 0 145.01-65.26 145.01-145.02M278 480.65v-35h-8.8v44.77c0 74.39 60.86 135.25 135.25 135.25h18.57c-79.76 0-145.01-65.26-145.01-145.02"
        />
        <path
          fill="#eee"
          d="M431.01 495.42c-43.08 0-83.56-5.1-113.98-14.37-29.45-8.97-46.33-21.15-46.33-33.42s16.89-24.45 46.33-33.42c30.42-9.27 70.9-14.37 113.98-14.37s83.56 5.11 113.98 14.37c29.45 8.97 46.33 21.15 46.33 33.42s-16.89 24.45-46.33 33.42c-30.42 9.27-70.9 14.37-113.98 14.37"
        />
        <path
          fill="#fff"
          d="M431.01 401.34c42.93 0 83.26 5.08 113.55 14.31 28.77 8.76 45.27 20.42 45.27 31.99s-16.5 23.22-45.27 31.98c-30.29 9.23-70.61 14.31-113.55 14.31s-83.26-5.08-113.55-14.31c-28.77-8.76-45.27-20.42-45.27-31.98s16.5-23.22 45.27-31.98c30.29-9.23 70.61-14.31 113.55-14.31m0-3.01c-89.37 0-161.82 22.07-161.82 49.29s72.45 49.29 161.82 49.29 161.82-22.07 161.82-49.29-72.45-49.29-161.82-49.29"
        />
        <path
          fill="#bbd2db"
          d="M578.15 463.42c0 21.04-118.97 30.54-147.14 30.54s-148.98-11.6-148.98-32.64 64.33-43.54 148.98-43.54 147.14 24.6 147.14 45.64"
        />
        <path
          fill="#fff"
          d="M431.01 402.34c42.84 0 83.06 5.07 113.26 14.26 27.9 8.5 44.56 20.1 44.56 31.03s-16.66 22.53-44.56 31.03c-30.2 9.2-70.42 14.26-113.26 14.26s-83.06-5.07-113.26-14.26c-27.9-8.5-44.56-20.1-44.56-31.03s16.66-22.53 44.56-31.03c30.2-9.2 70.42-14.26 113.26-14.26m0-4c-89.37 0-161.82 22.07-161.82 49.29s72.45 49.29 161.82 49.29 161.82-22.07 161.82-49.29-72.45-49.29-161.82-49.29"
        />
        <path
          fill="#f7f1ea"
          d="M463.63 475.73c-3.05 0-6.2-.13-9.43-.42a.998.998 0 1 1 .17-1.99c12.51 1.1 24.89-.08 34.83-3.31 8.5-2.76 14.43-6.86 15.48-10.7.92-3.34-2.23-5.64-5.04-6.99a.996.996 0 0 1-.47-1.33c.24-.5.83-.71 1.33-.47 6.65 3.19 6.68 7.21 6.1 9.32-2.24 8.19-19.81 15.89-42.99 15.89Z"
        />
        <path
          fill="#f7f1ea"
          d="M484.85 457.89a1.008 1.008 0 0 1-.97-1.28c.54-1.91.36-3.54-.57-4.99-2.04-3.19-7.53-5.44-16.77-6.88a.996.996 0 1 1 .31-1.97c9.84 1.53 15.78 4.08 18.15 7.78 1.24 1.93 1.51 4.16.8 6.62-.13.44-.53.73-.96.73ZM359.45 460.6c-.14 0-.29-.03-.43-.1-6.65-3.19-6.68-7.21-6.1-9.32 2.54-9.27 24.68-17.9 52.42-15.47.55.05.96.53.91 1.08-.05.55-.52.96-1.08.91-12.52-1.1-24.89.07-34.83 3.31-8.5 2.76-14.43 6.86-15.48 10.7-.92 3.34 2.23 5.64 5.04 6.99.5.24.71.84.47 1.33-.17.36-.53.57-.9.57Z"
        />
        <path
          fill="#f7f1ea"
          d="M396.63 469.67c-6.33 0-21.9-4.8-22.84-11.37-.59-4.15 4.12-7.62 14.39-10.62a.99.99 0 0 1 1.24.68c.15.53-.15 1.09-.68 1.24-8.78 2.56-13.38 5.55-12.97 8.41.71 4.98 14.77 9.65 20.86 9.65.55 0 1 .45 1 1s-.45 1-1 1ZM429.23 466.94c-2.2 0-4.18-.06-5.78-.18-2.22-.18-4.09-.31-5.69-.42-5.44-.38-7.93-.56-11.13-1.6a.993.993 0 0 1-.64-1.26c.17-.52.73-.81 1.26-.64 2.98.96 5.23 1.12 10.66 1.51 1.6.11 3.47.25 5.7.42 8.85.71 30.41-.9 34.4-1.85 8.17-1.94 10.95-4.54 10.83-6.32-.21-3.1-8.24-7.22-25.38-8.95-.98-.1-9.89-.95-21.68-.59-5.1.16-18.15 2.76-20.78 4.73-.45.33-1.07.24-1.4-.2-.33-.44-.24-1.07.2-1.4 3.28-2.45 16.88-4.97 21.92-5.12 11.91-.36 20.95.5 21.94.6 16.68 1.69 26.84 5.73 27.18 10.81.23 3.47-4.16 6.46-12.37 8.4-3.45.82-18.8 2.08-29.23 2.08Z"
        />
        <path
          fill="#f7f1ea"
          d="M432.62 460.3c-1.79 0-17.54-.12-17.54-4.36s15.74-4.36 17.54-4.36 17.54.12 17.54 4.36-15.74 4.36-17.54 4.36Zm-15.48-4.36c.85.9 6.39 2.36 15.48 2.36s14.63-1.46 15.48-2.36c-.85-.9-6.39-2.36-15.48-2.36s-14.63 1.46-15.48 2.36Z"
        />
        <path
          d="M663.2 676.29c-1.84.05-6.18 0-8.07-2.09-3.51-3.86-3.19-1.92-2.84-.82.57 1.81-2.8-1.72-3.97-2.22-1.97-1.52-3.34-1.7-3.27.63.09 2.76-8.24-5.52-9.2-5.46 1.23 4.14-.86 2.66-5.23-.89-3.09-2.52-3.31-6.67-6.29-5.64.07-1.73-2.58.99-1.57 2.4 3.53 4.95-8.19-6.51-12.8-7.83-4.24-1.21-7.57-2.41-9.99-4.05-.22.97-.47 1.89-.76 2.74-3.69 10.99-12.29 12.83-27.56 12.83-7.49 0-30 12.18-22.58 6.26 2.11-1.68-.67-6.91-1.32-4.28-4.03-2.82-6.14 3.32-11.87 5.78-8.07 3.45-11.85 4.78-8.23-.91-1.42-.5-17.46 8.35-16.14 4.24 1.11-3.45-1.04-3.78-4.62-2.35-1.98.26-8.57 4.12-6.92 1.63.98-1.48 2.3-4.26-4.62.02-3.72 2.31-10.27.56-13.03-.33-5.67-1.81.16-19.77 9.04-25.11 7.75 5.12 113.81-17.71 113.81-17.71s61.14 25.01 55.65 25.03c5.67 3.76 6.54 18.01 2.38 18.14Z"
          opacity=".08"
        />
        <path
          fill="#b5d0b9"
          d="M601.52 642.48c-.35 2.9-.88 5.39-1.6 7.53-3.66 10.89-12.18 12.71-27.3 12.71-7.42 0-29.71 12.07-22.37 6.21 2.1-1.66-.66-6.85-1.3-4.25-3.99-2.79-6.09 3.3-11.76 5.72-8 3.42-11.74 4.73-8.15-.9-1.4-.5-17.29 8.27-15.99 4.2 1.09-3.42-1.02-3.75-4.58-2.32-1.96.26-8.48 4.08-6.85 1.61.97-1.47 2.27-4.21-4.58.02-3.69 2.29-10.18.55-12.9-.33-6.11-1.94 1.23-22.76 11.27-25.95-8.15-2.36 15.18-4.77 4.77-7.22 11.19-6.87 8.92-9.56 16.51-9.8-2.12-1.23 2.22-.12-3.78-2.32 15.56-6.8 13.91-13.3 28.69-12.66-2.93-3.26-4.3-2.12-9.44-3.59.69-.54 11.97-9.11 19.41-11.74 11.1-3.95 23.64-2.83 35.09 0 2.03.49 8 4.23 9.47 10.11.47 1.86 2.91 6.33 4.23 9.09.28.61.52 1.13.66 1.53 2.93 7.84 1.77 11.91.5 22.36Z"
        />
        <path
          d="M601.52 642.48c-.35 2.9-.88 5.39-1.6 7.53-5.03-2.86-6.94-6.99-5.67-15.04 1.13-7.08 1.13-9.96 4.51-14.55.31-.42.9-1.08 1.6-1.82.28.61.52 1.13.66 1.53 2.93 7.84 1.77 11.91.5 22.36Z"
          opacity=".08"
        />
        <path
          fill="#b5d0b9"
          d="M660.95 655.05c5.44-.02-8.51-5.61-1.67-5.29-5.68-6.19-3.81-7.46-8.44-8.94 1.51-.39-1.35-.46 2.73-.77-8.38-6.93-6.22-10.64-15.45-12.85 2.38-1.49 3.03-.55 6.46-.55.31.42-5.53-7.55-9.9-10.66-6.15-4.39-14.07-5.9-21.62-6.18-1.34-.05-5.67 1.21-7.61 4.57-.75 1.3-4 4.47-4.89 5.67-3.18 4.32-3.19 7.03-4.24 13.69-1.78 11.25 3.07 14.37 14.23 17.56 4.57 1.31 16.18 12.66 12.68 7.76-1-1.4 1.62-4.1 1.55-2.38 2.95-1.02 3.17 3.09 6.23 5.59 4.32 3.52 6.41 4.99 5.19.89.95-.07 9.19 8.14 9.11 5.4-.07-2.3 1.29-2.13 3.24-.62 1.16.5 4.5 4 3.94 2.2-.34-1.09-.66-3.01 2.81.81 1.87 2.06 6.18 2.13 8 2.07 4.12-.13 3.26-14.24-2.37-17.97Z"
        />
        <path
          fill="#a2b8ab"
          d="M637.29 647.54c-.61-1.21-1.21-2.41-1.84-3.61-3.44-6.56-7.65-12.86-13.37-17.56-5.73-4.7-13.15-7.67-20.52-6.9 4.14 1.95 7.66 4.99 11.56 7.38 2.21 1.35 4.54 2.5 6.75 3.85a43.24 43.24 0 0 1 8.16 6.42c3.97 3.97 7.15 8.68 11.17 12.61M534.14 645.61c1.43-1.55 2.85-3.1 4.31-4.63 7.98-8.37 16.99-16.02 27.6-20.62 10.61-4.6 23.03-5.87 33.75-1.55-7.05 1.15-13.63 4.2-20.51 6.12-3.89 1.09-7.88 1.81-11.78 2.88a68.252 68.252 0 0 0-15 6.13c-7.67 4.26-14.46 9.96-22.17 14.14"
        />
        <path
          fill="#a2b8ab"
          d="M597.31 618.84c1.31.66 4.75 1.9 6.14 1.41.5-.18.12-1.79-.64-2.41-.19-.15-.41-.79-.8-.96-.5-.22-1.98-.03-2.76-.55-.46-.3-3.26 1.84-1.93 2.51Z"
        />
        <path
          fill="#8ba1ad"
          d="M319 576.8c-6.41-10.9-10.06-35.32-1.77-45.43 10.93-13.33 9.67-18.04 7.39-26.59a66.807 66.807 0 0 1-2.66-23.35c.18-3.14 1.29-4.26 2.19-4.66.83-.36 1.8-.22 2.48.38a4.326 4.326 0 0 1 1.09 4.31l-2.7-.62c-.03.22-.05.47-.07.75a64.09 64.09 0 0 0 2.56 22.41c2.37 8.88 3.93 14.74-7.97 29.26-7.29 8.89-3.98 31.78 2.03 42.01l-2.58 1.52Z"
        />
        <path
          fill="#c10c15"
          d="m357.46 636.05-49.36 10.83a7.08 7.08 0 0 1-8.42-5.39l-12.9-58.85c-.17-.76 0-1.56.45-2.19l5.79-8.16c.4-.56.99-.95 1.66-1.1l43.49-9.54c.75-.16 1.53-.01 2.16.42l8.69 5.99c.58.4.98 1 1.14 1.68l12.7 57.88c.82 3.81-1.58 7.58-5.39 8.42"
        />
        <path
          fill="#fff"
          d="m345.2 617.48-11.35-7.34c3.22-7 .16-15.29-6.84-18.52-7-3.22-15.29-.16-18.52 6.84-3.22 7-.16 15.29 6.84 18.52a13.945 13.945 0 0 0 16.35-3.5l11.35 7.34a1.989 1.989 0 0 0 2.16-3.34m-21.89-3.43c-5.37 1.15-10.65-2.27-11.8-7.64-1.15-5.37 2.27-10.65 7.64-11.8 5.37-1.15 10.65 2.27 11.8 7.64 1.14 5.37-2.28 10.65-7.64 11.8"
        />
        <path
          fill="none"
          stroke="#a9bfc9"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="2"
          d="m310.49 573.63 12.65-2.61"
        />
        <path
          fill="#c7a58c"
          d="m214.87 333.51 36.38 78.94s-11.3 9.99-3.5 16.83c7.8 6.85 19.26 10.49 21.32 23.59.52 1.87 4.44 3.77 4.57-1.75.13-5.52-3.46-27.66-9.28-39.09-5.22-17.97-17.95-75.3-19.41-80.76-7.54 1.6-30.07 2.24-30.07 2.24Z"
        />
        <path
          fill="#e0c1aa"
          d="m216.7 338.45 39.13 77.64s-10.95 10.38-2.91 16.95c8.04 6.57 19.62 9.82 22.14 22.84.58 1.85 4.57 3.61 4.5-1.91-.07-5.52-4.42-27.52-10.64-38.75-5.84-17.78-20.58-74.66-22.24-80.06-7.48 1.86-29.98 3.29-29.98 3.29Z"
        />
        <path
          fill="#90a898"
          d="M213.29 265.69s-14.35 4.45-14.3 23.21c-2.95 19.28-7.14 27.39-12.73 29.46 14.06 12.7 18.71 25.59 50.48 18.21 10.62-2.3 18.18-1.41 22.53 0-3.28-12.81-8.77-31.59-12.79-36.26-8.62-4.91-16.56-5.53-21.1-11.42-4.54-5.89-12.09-23.21-12.09-23.21Z"
        />
        <path
          fill="#e0c1aa"
          d="M384.85 245.83c-.27.84 10.61-5.34 12.16-3.89s5.95 1.76 5.52-.23-5.4-4.71-7.14-4.52-8.49.47-8.49.47-1.78 7.34-2.04 8.17Z"
        />
        <path
          fill="#90a898"
          d="M318.89 251.06c5.86.36 11.73.08 17.52-.84 7.74-1.5 43.41-14.67 52.13-12.79-.03 0 .25.02.08.34-.95 2.67-1.7 5.42-2.23 8.21a38.988 38.988 0 0 1-8.9 3.1c-5.92 1.43-38.36 13.16-49.55 14.93s-15.34 1.65-17.6-1.59c-2.26-3.24 8.56-11.35 8.56-11.35Z"
        />
        <path
          fill="#e0c1aa"
          d="M390.62 237.62c-.74.7 2.78 1.19 1.72 5.14 0-.06 0 .03-.01.12-.3 1.49 2.59-.08 2.59-1.1s.98 1.64 1.3.1c.31-1.54-1.65-4.26-1.65-4.26-1.31-.11-2.63-.11-3.94 0Z"
        />
        <path
          fill="#bbd2db"
          d="M436.87 323.3c-1.46-1.1-9.87 15.84-9.49 28.83s6.04 17.47 9.49 17.78 8.99-7.39 6.91-19.03c-2.08-11.65-5.46-26.48-6.91-27.58Z"
        />
        <path
          fill="#fff"
          stroke="#fff"
          stroke-linejoin="round"
          d="M441.73 359.21c.44 2.77-3 13.17-8.38 5.98 4.93 2.05 7.06-3.97 8.38-5.98Z"
          opacity=".8"
        />
        <path
          fill="#d5ebf1"
          d="M259.96 230.9s-26.74-56.63-24.22-95.35c2.52-38.72 5.03-56.15 9.99-56.16 4.96-.01 23.92 30.03 25.92 86.29 1.13 32.01-.6 52.71.03 65.22.47 9.25 3.45 14.09 3.45 14.09l-4.8 2.65-10.36-16.74Z"
          opacity=".7"
        />
        <path
          fill="#d5ebf1"
          d="M266.3 244.73s-62.57-59.06-68.54-96.77c-7.02-24.21-10.19-34.21-12.46-38.19s-2.95-23.01 25.67 17.18c28.63 40.19 40.13 75.32 43.33 82.46 3.2 7.14 12.32 26.37 18.78 33.54-6.35 4.19-6.78 1.78-6.78 1.78Z"
          opacity=".69"
        />
        <path
          fill="#fff"
          d="M193.8 106.03c18.92 34.4 17.3 52.83 23.68 61.16 6.39 8.33 11.72 6.58 33.5 33.95-6.88-17.39-29-67.31-57.19-95.11Z"
          opacity=".18"
        />
        <path
          fill="#fff"
          d="M251.95 133.89c1.46 12.03 14.64 41.64 21.13 68.64-.67-27.36-1.96-47.24-3.11-58.62s-8.17-48.44-19.49-60.35c1.51 11.11.02 38.3 1.48 50.33Z"
          opacity=".2"
        />
        <path
          fill="#e0c1aa"
          d="M193.28 254.05s-13.84-.89-27.48-16.59c-2.98-2.86-4.11 1.53 0 5.74s5.32 5.54 5.64 6.6a19.6 19.6 0 0 1-5.64-3.08c-.74-.54-2.73 1.57 1.05 4.87 3.78 3.29 13.7 10.3 29.24 10.01 15.54-.29-2.81-7.56-2.81-7.56Z"
        />
        <path
          fill="#90a898"
          d="M276.75 244.33c-20.33 2.02-24.46 5.69-37.39 12.75-1.21.66-20.27 5.35-25.56 7.03-.52.16-.8.4-.75 1.63s5.16 17.92 14.15 26.04c8.99 8.12 20.81 9.83 20.81 9.83s1.87.12 1.47-.75c-1.12-2.45-5.15-7.51 7.79-13.59 12.94-6.08 32.98-1.48 43.96-10.75 6.97-12.25 4.68-12.26 4.68-12.26s-8.88-15.64-12.69-17.76 6.21-4.42-16.47-2.16Z"
        />
        <path
          fill="#a3baac"
          d="M190.2 252.62c-1.38 6-6.54 10.33-5.01 10.88s94.81-3.77 99.25-4.74 7.36-3.31 7.06-6.13.04-7.28-3.93-7.7-51.17 6.7-97.37 7.69Z"
        />
        <path
          fill="#a00006"
          d="M290.31 250.13c.08 3.36-7.6 20.55 5.15 39.93 4.78-4.14 19.05-23.1 18.01-26.56s-13.73-20.19-13.73-20.19-9.51 3.46-9.43 6.83Z"
        />
        <path
          fill="#c00e15"
          d="M290.33 250.12c.08 3.36-1.86 38.24 17.46 47.59 4.78-4.14 6.91-32.86 5.87-36.32s-13.9-18.09-13.9-18.09-9.51 3.46-9.43 6.82Z"
        />
        <path
          fill="#a00006"
          d="M293 246.21s2.25 37.25 17.49 45.92c.12-.52.2-.55.29-.96-4.63-7.23-16.11-32.57-17.25-44.43-.2-1.05-.52-.53-.52-.53Z"
        />
        <path
          fill="#a00006"
          d="M293.02 246.2s4.85 22.62 20.38 28.32c.06-.57.08-.46.09-.81-5.52-4.24-15.42-15.35-19.83-27.14-.46-.96-.64-.37-.64-.37Z"
        />
        <path
          fill="#a00006"
          d="M294.85 248.22s2.64-4.39 3.17-1.74c.53 2.66 7.03 16.08 15.84 16.38.29-4.77-.53-3.31-1.15-4.36s-11.62-17.95-11.62-17.95l-6.23 7.66Z"
        />
        <path
          fill="#886a51"
          d="M330.2 250.18s14.52 11.14 21.32-8.38c-6.34 2.51-9.88-.8-9.82-9.38.05-8.58-13.02 9.38-13.02 9.38l1.52 8.38Z"
        />
        <path
          fill="#e0c1aa"
          d="M298.75 234.81c-.02-.07 3.23 26.76 16.63 27.06 13.39.31 17.73-12.15 21.43-27.95-15.04.9-38.03.95-38.05.88Z"
        />
        <path
          fill="#a18064"
          d="M332.43 233.18s-3.69 16.2 12.48 15.95c-12.88-6.11-4.63-17.81-4.63-17.81l-7.85 1.86ZM289.61 244.25c-3.82 1.18-12.67 3.32-12.85-3.91-.17-7.23 7.15-5.83 7.15-5.83s-4.19 2.67 1.04 4.97 9.15-6.73 9.15-6.73l3.42 1.19s-4.09 9.13-7.91 10.31Z"
        />
        <path fill="#e0c1aa" d="M396.21 245.19c.17 4.96 4.36 5.18 6.55 4.72s-4.77-5.01-4.77-5.01-1.18.17-1.78.29Z" />
        <path
          fill="#886a51"
          d="M306.7 233.97s-3.18 14.72-14.54 15.93-12.38-8.09-9.67-10.93c2.71-2.84 4.88-2.99 7.01-2.17-4.4 2.34-4.53 4.81-2.37 4.61a7.692 7.692 0 0 0 6.76-7.43c.33-5.35 12.81 0 12.81 0Z"
        />
        <path
          fill="#62544a"
          d="M293.6 234.64c13.84 5.34 36.98 9.35 48.61 2.76-2.15-5.26 3.71-7.36 3.71-7.36l-46.89 3.8s-19.27-4.54-5.43.8Z"
          opacity=".5"
        />
        <path
          fill="#e0c1aa"
          d="M393.56 237.59s2.08-1.26 7.56.42c2.82.89 6.83 5.76 5.56 8.64a5.918 5.918 0 0 1-3.27 3.1c-2.58.83-2.75-1.56-4.01-2.03 0 0-2.2-1.21-2.26-2.23 2.01-1.94 2.1-3.46 1.37-4.11s-4.95-3.79-4.95-3.79Z"
        />
        <path
          fill="#6c4f37"
          d="M324.04 254.18c-1.18 1.56-3.05 1.89-4.9 1.93-2.19.11-4.34-.55-6.1-1.86a.727.727 0 0 1-.4-.91c.14-.36.55-.54.91-.4 1.64.95 3.45 1.58 5.33 1.86.82.06 1.64.02 2.45-.13a3.6 3.6 0 0 0 2.01-1c.36-.42 1.04.06.7.51"
        />
        <path
          fill="#e6c29a"
          d="M266.56 224.11c-3.52 4.15 20.35 12.75 51.37 12.19 31.02-.56 55.14-6.38 49.74-12.19-5.4-5.82-28.31-5.98-28.31-5.98s-7.31-19.55-21.44-19c-14.13.55-20.97 9.53-24.8 19-5.95-.04-23.05 1.83-26.57 5.98Z"
        />
        <path
          fill="#90a898"
          d="M295.09 213.99c-1.07 1.84-1.9 3.81-2.47 5.86-.02.06-.11.32.1.44 3.63 2.25 28.47 9.99 48.08 2.52.04-.02.29-.22.24-.4-.78-2.74-1.88-5.38-3.3-7.85-6.49 1.7-21.38 4.09-42.64-.57Z"
        />
        <path
          fill="#c7a58c"
          d="M397.48 240.93c.54-.05-9.89 3.26-10.84 3.7.22-1.03.24-1.04.42-1.74 3.4-1.01 6.89-1.66 10.42-1.95Z"
        />
        <path
          fill="#e6c29a"
          d="M435.44 304.56c-2.51-3.57-17.51-14.54-28.44-13.83.91-1.6 1.66-3.38 2.26-5.31.48-.92.85-2.04.99-3.36 2.03-3.24 5.6-9.5 6.43-14.78 1.13-7.14-2.84-22.26-14.13-24.52-10.13-2.02-16.78-.78-22.69 11.48-.33.26-.61.58-.84.94-5.9 5.03-21.51 20.86-22.04 30.19-.06 5.3 1.99 10.31 10.97 16.51 8.99 6.21 18.81 7.8 22.74 4.25.35-.32.79-.66 1.26-1.01 23.2-8.29 35.95 1.59 35.95 1.59s1.28 3.42 4.06 2.79c2.79-.63 4.66-2.44 3.48-4.94Zm-33.48-58.87c9.08 1.81 12.77 14.69 11.76 21.11-.52 3.31-2.34 7.21-4.04 10.3-1.33-4.32-5.01-9.81-13.04-16.33-5.9-4.79-10.12-6.88-13.02-7.29 4.8-8.69 9.93-9.46 18.34-7.78Z"
        />
        <path
          fill="#c59b78"
          d="M384.25 258.99c-3.1-6.19-1.06-7.78 13.23-3.38a17.419 17.419 0 0 1 11.98 12.48c1.41 4.88.58 9.92-1 11.14-3.08 2.38-21.11-14.04-24.21-20.24Z"
        />
        <ellipse
          cx="403.26"
          cy="259.72"
          fill="#e6c29a"
          rx="2.58"
          ry="3.24"
          transform="rotate(-44.03 403.238 259.713)"
        />
        <path
          fill="#c59b78"
          d="M431.13 306.12c-.88.74-1.81 1.61-1.25 2.11s2.44.2 3.29-.34 1.94-1.69 1.79-2.12-.18-.88-1.26-.6c-.88.26-1.73.58-2.57.95Z"
        />
      </svg>
    </message-image>
    <message-detail>
      <h2>{textResources.messages.responseError.headline}</h2>
      <p>{textResources.messages.responseError.text}</p>
      <button onClick={() => controller.onRestartSearch()}>{textResources.messages.responseError.retryBtn}</button>
    </message-detail>
  </message>
);

export default ResponseErrorTemplate;
